import { useState } from 'react';
import { BottomNav } from '../components/ui';
import { Card, Empty, Kick, Screen, Seg, Sp, Top, IB } from '../components/p';
import { CreateButton } from '../components/nav';
import { OrdersView } from './Orders';

/** The Menus tab (P05 / P11): one-off orders by day, and the Menus customers order from. */
export function Menus() {
  const [view, setView] = useState<'orders' | 'menus'>('orders');
  return (
    <>
      <Screen gap={16}>
        <Top>
          <div className="p-stack"><Kick>{view === 'orders' ? new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' }) : 'Your Menus'}</Kick><h1 className="p-h1">{view === 'orders' ? 'Orders' : 'Menus'}</h1></div>
          <Sp />
          <IB icon="search" label="Search" to="/search" />
        </Top>
        <Seg label="Orders or Menus" value={view} onChange={setView} options={[{ value: 'orders', label: 'Orders' }, { value: 'menus', label: 'Menus' }]} />
        {view === 'orders'
          ? <OrdersView />
          : <Card><Empty title="No Menus yet">A Menu is a link your customers order from: a festival, a quick sale or every day.</Empty></Card>}
      </Screen>
      {view === 'orders' ? <CreateButton to="/orders/new" label="New order" /> : <CreateButton />}
      <BottomNav />
    </>
  );
}
